import ScriptingEffect from './ScriptingEffect.js';
import {pipe} from './pipe.js';
import {alt} from './alt.js';
import {density} from './density.js';
import {gte} from './compare.js';
import {
    switchOutput,
    cond,
    execute,
    notes,
    steps,
    prob,
} from './lang.js';

class DensityEffect extends ScriptingEffect {
    constructor(track) {
        super("Density", track);
        this.clear();

        this.newVar("limit", 4, 1, 32);
        this.newVar("windowSize", 4, 1, 32);

        this.numberOfOutputs = 2;
    }

    isRealTime() { return true; }

    get documentation() {
        return [
            "Sends triggers to output 2 when the number of triggers of the last few steps exceeds a certain threshold.",
            "All other triggers go to output 1."
        ];
    }

    isRealTime() {
        return false;
    }

    clear() {
        this.myScript = pipe(
            cond(
                gte(this.var("limit"), density(this.var("windowSize"))),
                switchOutput(1),
                switchOutput(0)));
    }

    get script() {
        return this.myScript;
    }

    getCopy(track, ignoreId=true) {
        let fx = new DensityEffect(track);
        fx.fromJson(fx.getJson(), ignoreId);
        return fx;
    }
}


export default DensityEffect;
